import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform, InputAccessoryView } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import BarcodeScannerComponent from "../widgets/BarCodeScannerComponent";
import colors from "../../constants/colors";
import SearchInventory from "./searchInventoryTypes";
import SearchIngredientsByLot from "./searchIngredientsByLot";
import { getIngredientLotsByName } from "../../actions/submissions";
//import { Audio } from 'expo-av';
import { getComponentByanotherComponentId, getComponentSubmit, getIosCellHeight, getLotCodeString, getComponentSubmissionByDefaultLabel, getTotalSelected, getRequiredAmount, inputFocus, validateDecimals, lotFieldHasMeaningfulLots, receivingRowHasProductForLotsPicker, hasLotCodeString, isPlaceholderLotObject } from "../../utils";
import KeyboardBar from "../widgets/KeyboardBar";
import LotsByLocation from "../widgets/LotsByLocation";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
import {
  getRemainingLotAmount,
  isLotFullyAllocated,
} from "../../utils/shipmentAllocations";

class Lotcode extends Component {
  inputRef = createRef();
  _interval = null;
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initial,
      dialogVisible: false,
      height: (props.isRecipe && props.defaultLabel == "lot") || !props.isInventoryReceivingForm ? 50 : 27,
      heightIOS: (props.isRecipe && Platform.OS == "ios" && props.defaultLabel == "lot") ? 44 : 27,
      reset: false,
      ingredientOptions: (props.complete_date && props.isRecipe && props.options) ? props.options : [],
      ingredientName: "",
      scan: false,
      showLotsByLocation: false,
      inputAccessoryViewID: 'lot-' + props.id + '-' + props?.position,
      minorAmount: false,
      loadedLots: false,
      scanerCanceled: false,
      leftWriting: typeof this.props.initial == "string" && this.props.initial ? true : (typeof this.props.initial == "object" && getLotCodeString(this.props.initial)) ? true : false,
      quantity: -1,
      quantityChanged: false,
      loadingBatchSizeChange: false,
      softFocus: props.scannerInput ? false : true,
      lotInputFocused: false,
    };
    this.textInputRef = createRef(null); 
    this._lotsViewGen = 0;
    /** After closing LotsByLocation, block auto-reopen from focus refire only. */
    this._embeddedLotsClosedUntil = 0;
    this._lotsPickerOpening = false;
  }

  shouldAllowEmbeddedLotsView() {
    return Date.now() >= this._embeddedLotsClosedUntil;
  }

  markLotsPickerClosed() {
    this._embeddedLotsClosedUntil = Date.now() + 400;
    this._lotsPickerOpening = false;
    this._lotsViewGen++;
  }

  isShipmentLotField() {
    const { isShipmentLog, defaultLabel } = this.props;
    return isShipmentLog && (defaultLabel === "lotcode" || defaultLabel === "lotcode_finished" || defaultLabel === "lotcode_wip");
  }
  shouldFetchIngredientLots() {
    const { showInventorySearch, showWipSearch } = this.props;
    return !!(showInventorySearch || showWipSearch || this.isShipmentLotField());
  }
  /** Receiving lot field: user must enter non-empty search text before opening the picker. */
  hasLotSearchText(value) {
    const { isInventoryReceivingForm, defaultLabel } = this.props;
    if (!isInventoryReceivingForm || defaultLabel == "lot") return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (Array.isArray(value)) return getLotCodeString(value).trim().length > 0;
    return false;
  }
  componentDidMount() {
    this._onLotsPickerClosed = () => this.markLotsPickerClosed();
    if (typeof window !== "undefined") {
      window.addEventListener("gohaccp-lots-picker-closed", this._onLotsPickerClosed);
    }
    const { showInventorySearch, isRecipe, components, position, submission, defaultLabel, section_id, showWipSearch, isInvoice, isInventoryTransfer, isShipmentLog, newReport, status, initial, id, updateComponentLotCodeschoiceList, complete_date } = this.props;

    if (this.shouldFetchIngredientLots() && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog) && !(isRecipe && complete_date)) {
      var sectionComponent = components.find((c, idx) => (c?.type == "section") && (section_id == c.section_id));
      var ingredientComponent = components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id));
      var ingredientName = "";
      if (ingredientComponent?.length > 0) {
        var ingredientComponentId = ingredientComponent[0].id;
        if (submission[ingredientComponentId]) {
          if (submission[ingredientComponentId][position]) {
            ingredientName = submission[ingredientComponentId][position];
            if (ingredientName && ingredientName != this.state.ingredientName) {
              var data = {
                name: ingredientName,
                type: (ingredientComponent[0]?.defaultLabel == "ingredient" || ingredientComponent[0]?.defaultLabel == "itemName") ?
                  showWipSearch ?
                    "wip" : "ingredient" : ((isInventoryTransfer || isShipmentLog) && ingredientComponent[0]?.defaultLabel == "item") ?
                    sectionComponent?.defaultLabel == "finishedGoods" ?
                      "fg" : sectionComponent?.defaultLabel == "workInProgress" ?
                        "wip" : sectionComponent?.defaultLabel == "packagingMaterials" ?
                          "packagingMaterial" : "ingredient" : isInvoice ?
                      "fg" : "packagingMaterial"
              }
              if (isRecipe) data.forRecipe = true;
              this.setState({ ingredientName, ingredientOptions: [] });
              this.props.getIngredientLotsByName(data, (res) => {
                if (res?.lots?.length) {
                  var val = [];
                  this.setState({ ingredientOptions: res.lots }, () => {
                    //Save actual lotcodes in component choice list
                    if(updateComponentLotCodeschoiceList)updateComponentLotCodeschoiceList(id, res.lots, position);
                    if (isShipmentLog) {
                      this.preselectShipmentLotsIfReady(this.props.submission || submission);
                    }
                  });
                  //Set First lot code as prefilled data
                  var initialValue = initial ? initial : "";
                  if ((!status || status == "in_progress") && !isShipmentLog && (!initial || typeof initial == "object" && initialValue[0] == "default_lot")) {
                    var p = (position + 1) * 300;
                    //val.push(res.lots[0]);
                    val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(res?.lots)));
                    //Wait to submission be updated correctly
                    //if (!isInvoice)
                      setTimeout(() => {
                        this.onSelectItem(val, true);
                        this.setState({ loadedLots: true });
                      }, p);
                  }
                } else {
                  this.setState({ loadedLots: true });
                }
              });
            } else {
              this.setState({ loadedLots: true });
            }
          }
        }
      }
    }
  }
  componentWillUnmount() {
    if(this._interval)clearTimeout(this._interval);
    if (typeof window !== "undefined" && this._onLotsPickerClosed) {
      window.removeEventListener("gohaccp-lots-picker-closed", this._onLotsPickerClosed);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showInventorySearch, isRecipe, components, position, defaultLabel, section_id, showWipSearch, isInvoice, isInventoryTransfer, isShipmentLog, id, onChange, openBarCodeScanner, focusLotCode, handleFocusOnElement, complete_date, isReceivingLog, updateComponentLotCodeschoiceList } = this.props;
    const { submission, quantityChangedPosition } = nextProps;

    if (nextProps.initial != this.props.initial) {
      this.setState({ value: nextProps.initial });
    }
    if (isRecipe && nextProps.focusLotCode != focusLotCode && nextProps.focusLotCode && defaultLabel == "lot") {
      const focusLot = () => {
        if (this.textInputRef?.current) {
          inputFocus(this.textInputRef);
          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
        }
      };
      // Delay past SweetAlert close/focus restore so lot keeps focus
      setTimeout(focusLot, 150);
      setTimeout(focusLot, 350);
    }
    if (nextProps?.resetInventorySearch) {
      if ((nextProps?.resetInventorySearch?.changed != this.props.resetInventorySearch?.changed && nextProps?.resetInventorySearch?.position == this.props?.position && (isShipmentLog || isInventoryTransfer) && (this.props?.defaultLabel == 'lotcode_finished' || this.props?.defaultLabel == 'lotcode_wip' || this.props?.defaultLabel == 'lotcode'))) {
        // Clear the selected lot, but keep ingredientOptions so correcting quantity
        // (after an allocation alert) can re-preselect without refetching the item.
        this._lotQtySyncKey = null;
        const blockedQty = isShipmentLog ? this.getQuantityValueForLotSync(submission) : this.state.quantity;
        this.setState({
          value: [],
          reset: !this.state.reset,
          ...(isShipmentLog ? { quantity: blockedQty || 0 } : {}),
        });
        if (isShipmentLog) {
          this.onSelectItem([], false);
        }
      }
    }
    var ingredientComponent = components ? components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "packagingMaterial" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id)) : null;
    if (ingredientComponent?.length > 0) {
      var ingredientComponentId = ingredientComponent[0].id;
      if (submission[ingredientComponentId]) {
        if (!submission[ingredientComponentId][position] && submission[ingredientComponentId][position] != this.state.ingredientName) {
          this.setState({ ingredientName: "" });
        }
      }
    }
    //Show lots for item added in recipes
    if (this.shouldFetchIngredientLots() && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog
      //|| (isRecipe && this.props.batchSizeChanged != nextProps.batchSizeChanged)
    ) && !(isRecipe && complete_date)) {
      var sectionComponent = components.find((c, idx) => (c?.type == "section") && (section_id == c.section_id));
      //var ingredientComponent = components.filter((c, idx) => (c?.defaultLabel == "ingredient" || c?.defaultLabel == "name" || c?.defaultLabel == "item" || c?.defaultLabel == "itemName") && (section_id == c.section_id));
      //var ingredientName = "";
      if (ingredientComponent?.length > 0) {
        var ingredientComponentId = ingredientComponent[0].id;
        if (submission[ingredientComponentId]) {
          if (submission[ingredientComponentId][position]) {
            var ingredientName = submission[ingredientComponentId][position];
            if (ingredientName && (ingredientName != this.state.ingredientName
              //|| this.props.batchSizeChanged != nextProps.batchSizeChanged
            )) {
              var data = {
                name: ingredientName,
                type: (ingredientComponent[0]?.defaultLabel == "ingredient" || ingredientComponent[0]?.defaultLabel == "itemName") ?
                  showWipSearch ?
                    "wip" : "ingredient" : ((isInventoryTransfer || isShipmentLog) && ingredientComponent[0]?.defaultLabel == "item") ?
                    sectionComponent?.defaultLabel == "finishedGoods" ?
                      "fg" : sectionComponent?.defaultLabel == "workInProgress" ?
                        "wip" : sectionComponent?.defaultLabel == "packagingMaterials" ?
                          "packagingMaterial" : "ingredient" : isInvoice ?
                      "fg" : "packagingMaterial"
              }
              if (isRecipe) data.forRecipe = true;
              this.setState({ ingredientName, ingredientOptions: [] });
              this.props.getIngredientLotsByName(data, (res) => {
                if (res?.lots?.length) {
                  //if(nextProps.lotcodeFirstPreselection){
                  //  this.onSelectItem(["default_lot"], true);
                  //}
                  if (!isShipmentLog) {
                    var val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, JSON.parse(JSON.stringify(res?.lots)));
                    this.onSelectItem(val, true);
                    this.setState({ ingredientOptions: res.lots });
                  } else {
                    this.setState({ ingredientOptions: res.lots }, () => {
                      if (updateComponentLotCodeschoiceList) {
                        updateComponentLotCodeschoiceList(id, res.lots, position);
                      }
                      this.preselectShipmentLotsIfReady(nextProps.submission || submission, nextProps.quantityChanged);
                    });
                  }
                } else if (res?.lots?.length <= 0 && typeof this.state.value == "object" && this.state.value[0] == "default_lot") {
                  this.setState({ value: "" }, () => onChange(id, ""))
                }
              });
            }
          }
        }
      }
    }
    if (this.shouldSyncLotsFromQuantityChange()) {
      this.maybeSyncLotsFromQuantity(this.props, submission, nextProps.quantityChanged);
    }
    //Open Barcode scanner from keyboard text bar (Android)
    if (nextProps.openBarCodeScanner != openBarCodeScanner && nextProps.openBarCodeScanner) {
      this.showScanner(true);
    }
  }
  async handleBarCodeScanned(data) {
    const { onChange, id, options, isShipmentLog, isRecipe, isInvoice, isInventoryTransfer, setOpenBarcode, handleFocusOnElement } = this.props;
    const { value, ingredientOptions } = this.state;
    this.setState({ scan: false }, async () => {
      //Activate sound for barcode
      //const { sound } = await Audio.Sound.createAsync(require('../../../assets/audio/scanner-audio.mp3'));
      //await sound.playAsync();

      var newVal = [];
      if (typeof value == "object") {
        newVal = value
      }
      if (data) {
        if ((isShipmentLog && options?.length > 0) || ((isRecipe || isInvoice || isInventoryTransfer) && ingredientOptions?.length > 0)) {
          //var idx = newVal.findIndex(val => val?.lot == data);
          var optIdx = (isRecipe || isInvoice || isInventoryTransfer) ? ingredientOptions.find(opt => opt?.lot == data) : options.find(opt => opt?.lot == data);

          if (optIdx) {
            newVal = [optIdx];
          } else {
            newVal = data;
          }

          this.setState({ value: newVal });
          onChange(id, newVal);
        } else {
          this.setState({ value: data });
          onChange(id, data);
        }

      }
      if (setOpenBarcode) {
        setOpenBarcode(null);
      }
      //if(handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
    })


  }
  generateLotCode(max, min) {
    const { id, submissionSelected, onChange, lotConsecutive } = this.props;
    var val = submissionSelected?._id ? submissionSelected._id.slice(-8) + lotConsecutive : Math.floor(Math.random() * (max - min) + min);
    val = val.toString();
    this.setState({ value: val });
    onChange(id, val);
  }
  getMinChar(width) {
    var chrs = 26;
    switch (width) {
      case "small":
        chrs = 13
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return chrs;
  }
  getFirstDiv(width) {
    var val = 19;
    switch (width) {
      case "small":
        val = 11
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return val;
  }
  getSecondDiv(width) {
    var val = 28;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 19
        break;
      case "large":
        val = 26;
        break;
    }
    return val;
  }
  getThirdDiv(width) {
    var val = 31;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 24
        break;
      case "large":
        break;
    }
    return val;
  }
  onSelectItem(val, prepopulate) {
    const { onChange, id } = this.props;

    this.setState({ value: val });
    onChange(id, val, prepopulate);
  }
  shouldSyncLotsFromQuantityChange() {
    const { defaultLabel, isReceivingLog, isShipmentLog, isRecipe } = this.props;
    if (defaultLabel !== "lotcode" && defaultLabel !== "lotcode_finished" && defaultLabel !== "lotcode_wip") {
      return false;
    }
    return !!(isReceivingLog || isShipmentLog || isRecipe);
  }
  getQuantityValueForLotSync(submission) {
    const { defaultLabel, isShipmentLog, components, id, position } = this.props;
    if (defaultLabel === "lotcode_finished") {
      return getComponentSubmit(submission, components, "quantityFinishedGoods", id, position);
    }
    if (defaultLabel === "lotcode_wip") {
      return getComponentSubmit(submission, components, "quantityWIP", id, position);
    }
    if (defaultLabel === "lotcode" && isShipmentLog) {
      const ingredientQty = getComponentSubmit(submission, components, "quantityIngredient", id, position);
      if (ingredientQty) return ingredientQty;
      return getComponentSubmit(submission, components, "quantityPackaging", id, position);
    }
    return getComponentSubmit(submission, components, "quantity", id, position);
  }
  getSubmissionLots(submission) {
    const { id, position } = this.props;
    if (!submission || !submission[id]) return null;
    if (position || position === 0) return submission[id][position];
    return submission[id];
  }
  getExistingLotsForQuantitySync(submission) {
    const { value } = this.state;
    const submissionLots = this.getSubmissionLots(submission);

    if (Array.isArray(submissionLots) && submissionLots.length > 0 && typeof submissionLots[0] === "object" && (hasLotCodeString(submissionLots) || this.hasRealLotOptions(submissionLots))) {
      return JSON.parse(JSON.stringify(submissionLots));
    }
    if (Array.isArray(value) && value.length > 0 && typeof value[0] === "object" && (hasLotCodeString(value) || this.hasRealLotOptions(value))) {
      return JSON.parse(JSON.stringify(value));
    }
    return null;
  }
  unwrapLotOptionsList(list) {
    if (!Array.isArray(list) || !list.length) return null;
    if (this.hasRealLotOptions(list)) return JSON.parse(JSON.stringify(list));
    const { position } = this.props;
    const atPosition =
      (position || position === 0) && Array.isArray(list[position]) ? list[position] : null;
    if (atPosition && this.hasRealLotOptions(atPosition)) {
      return JSON.parse(JSON.stringify(atPosition));
    }
    // Do not fall back to another row's nested lot list — that caused cross-row
    // preselection (e.g. Mango lots applied to Dulce De Leche).
    return null;
  }
  getLotCodesForQuantitySync(submission) {
    const { options, isShipmentLog } = this.props;
    const fromIngredient = this.unwrapLotOptionsList(this.state.ingredientOptions);

    // Shipment: only use this row's fetched lots. Shared `options` can belong to
    // another table row after a sibling item selection.
    if (isShipmentLog) {
      if (fromIngredient) return fromIngredient;
      const fromOptions = this.unwrapLotOptionsList(options);
      // Only accept options when they look like a flat list for THIS row
      // (already unwrapped / row-scoped), not a multi-row choicelist blob.
      if (fromOptions && this.hasRealLotOptions(options)) return fromOptions;

      const submissionLots = this.getSubmissionLots(submission);
      if (Array.isArray(submissionLots) && submissionLots.length > 0 && (hasLotCodeString(submissionLots) || this.hasRealLotOptions(submissionLots))) {
        return JSON.parse(JSON.stringify(submissionLots));
      }

      const existingLots = this.getExistingLotsForQuantitySync(submission);
      if (existingLots && existingLots.length > 0 && (hasLotCodeString(existingLots) || this.hasRealLotOptions(existingLots))) {
        return existingLots;
      }

      return [];
    }

    const fromOptions = this.unwrapLotOptionsList(options);

    if (fromIngredient) return fromIngredient;
    if (fromOptions) return fromOptions;

    const submissionLots = this.getSubmissionLots(submission);
    if (Array.isArray(submissionLots) && submissionLots.length > 0 && (hasLotCodeString(submissionLots) || this.hasRealLotOptions(submissionLots))) {
      return JSON.parse(JSON.stringify(submissionLots));
    }

    const existingLots = this.getExistingLotsForQuantitySync(submission);
    if (existingLots && existingLots.length > 0 && (hasLotCodeString(existingLots) || this.hasRealLotOptions(existingLots))) {
      return existingLots;
    }

    return [];
  }
  preselectShipmentLotsIfReady(submission, quantityChanged) {
    if (!this.props.isShipmentLog || !this.shouldSyncLotsFromQuantityChange()) return;

    const { defaultLabel, id, components, position } = this.props;
    const qty = this.getQuantityValueForLotSync(submission);
    if (!qty) return;
    const qtyNum = parseFloat(qty);
    if (!qtyNum || Number.isNaN(qtyNum) || qtyNum <= 0) return;

    const submissionLots = this.getSubmissionLots(submission);
    // Already has a real selection (named lot OR inventory with lot: "")
    if (hasLotCodeString(submissionLots) || this.hasRealLotOptions(Array.isArray(submissionLots) ? submissionLots : [])) return;

    // Only preselect from this row's fetched lots (ingredientOptions), never sibling row options.
    if (!this.hasRealLotOptions(this.state.ingredientOptions)) return;
    const lotCodes = this.unwrapLotOptionsList(this.state.ingredientOptions);
    if (!lotCodes?.length) return;

    const val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes);
    if (!this.hasRealLotOptions(val) && !hasLotCodeString(val)) return;
    this.onSelectItem(val, false);
    if (typeof quantityChanged !== "undefined") {
      this.setState({ quantity: qty, quantityChanged });
    }
  }
  maybeSyncLotsFromQuantity(prevProps, nextSubmission, nextQuantityChanged) {
    if (!this.shouldSyncLotsFromQuantityChange()) return;

    const { position, quantityChangedPosition, isShipmentLog } = this.props;
    const submission = nextSubmission || this.props.submission;
    const quantityChanged = typeof nextQuantityChanged !== "undefined" ? nextQuantityChanged : this.props.quantityChanged;
    const actual = this.getQuantityValueForLotSync(submission);
    const past = this.getQuantityValueForLotSync(prevProps.submission);
    const quantityChangedNow = prevProps.quantityChanged !== quantityChanged;
    if (quantityChangedNow && this.state.quantityChanged !== quantityChanged) {
      this.setState({ quantityChanged });
    }

    const actualNum = parseFloat(actual);
    const submissionLots = this.getSubmissionLots(submission);
    const lotsMissing =
      isShipmentLog &&
      actualNum > 0 &&
      !hasLotCodeString(submissionLots) &&
      !this.hasRealLotOptions(Array.isArray(submissionLots) ? submissionLots : []);

    // Normal path: qty value changed. Recovery path: qty unchanged after an allocation
    // block cleared lots — still preselect when quantityChanged flips and lots are empty.
    if (String(actual) === String(past) && !(quantityChangedNow && lotsMissing)) return;
    if (quantityChangedPosition >= 0 && quantityChangedPosition != position) return;

    const syncKey = lotsMissing && String(actual) === String(past)
      ? `${position}:reselect:${String(actual)}:${String(quantityChanged)}`
      : `${position}:${String(past)}->${String(actual)}`;
    if (this._lotQtySyncKey === syncKey) return;

    // Closing LotsByLocation updates quantity to match the modal selection — do not
    // rebuild lots in FIFO order over the user's picks.
    if (
      (this._suppressLotQtySyncUntil && Date.now() < this._suppressLotQtySyncUntil) ||
      (typeof this.props.shouldSuppressLotQtySync === "function" && this.props.shouldSuppressLotQtySync())
    ) {
      this._lotQtySyncKey = syncKey;
      this.setState({ quantity: actual || 0, quantityChanged });
      return;
    }

    // Quantity cleared/zeroed: clear lot selection so leftover full-stock amounts
    // do not re-trigger partial allocation validation.
    if (isShipmentLog && (!actual || Number.isNaN(actualNum) || actualNum <= 0)) {
      this._lotQtySyncKey = syncKey;
      this.setState({ quantity: actual || 0, quantityChanged });
      this.onSelectItem([], false);
      return;
    }

    const synced = this.syncLotsFromQuantity(submission, quantityChanged);
    if (synced) {
      this._lotQtySyncKey = syncKey;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { defaultLabel, initial, isShipmentLog, options, submission } = this.props;
    if (
      this.shouldSyncLotsFromQuantityChange() &&
      prevProps.initial !== initial &&
      Array.isArray(initial) &&
      initial.length > 0 &&
      typeof initial[0] === "object"
    ) {
      this.setState({ value: initial });
    }
    // Intentionally do not preselect on shared `options` changes for shipment logs:
    // that list is component-wide and updates when another row selects an item.
    const prevIngredientCount = prevState?.ingredientOptions?.length || 0;
    const nextIngredientCount = this.state.ingredientOptions?.length || 0;
    if (
      isShipmentLog &&
      this.shouldSyncLotsFromQuantityChange() &&
      nextIngredientCount > 0 &&
      nextIngredientCount !== prevIngredientCount
    ) {
      this._lotQtySyncKey = null;
      this.preselectShipmentLotsIfReady(submission, this.props.quantityChanged);
    }
    if (
      isShipmentLog &&
      this.shouldSyncLotsFromQuantityChange() &&
      this.getQuantityValueForLotSync(submission) &&
      this.submissionHasOnlyPlaceholderLots(submission) &&
      this.hasRealLotOptions(this.state.ingredientOptions)
    ) {
      this._lotQtySyncKey = null;
      this.preselectShipmentLotsIfReady(submission, this.props.quantityChanged);
    }
    this.maybeSyncLotsFromQuantity(prevProps);
  }
  syncLotsFromQuantity(submission, quantityChanged) {
    if (!this.shouldSyncLotsFromQuantityChange()) return false;

    const { defaultLabel, isRecipe, isShipmentLog, components, id, position } = this.props;
    const actual = this.getQuantityValueForLotSync(submission);
    if (!actual) return false;

    // Shipment new preselection must use this row's fetched lots only.
    if (isShipmentLog) {
      const submissionLots = this.getSubmissionLots(submission);
      const hasExisting =
        hasLotCodeString(submissionLots) ||
        this.hasRealLotOptions(Array.isArray(submissionLots) ? submissionLots : []);
      if (!hasExisting && !this.hasRealLotOptions(this.state.ingredientOptions)) {
        return false;
      }
    }

    const lotCodes = this.getLotCodesForQuantitySync(submission);
    if (!lotCodes?.length) return false;
    this.setState({ quantity: actual, quantityChanged });

    if (isRecipe && defaultLabel === "lotcode") {
      const p = (position + 1) * 300;
      this.setState({ loadingBatchSizeChange: true });
      setTimeout(() => {
        const val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes);
        if (this.hasRealLotOptions(val) || hasLotCodeString(val)) {
          this.onSelectItem(val, false);
        }
        setTimeout(() => this.setState({ loadingBatchSizeChange: false }), 200);
      }, p);
      return true;
    }

    const val = this.getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes);
    if (!this.hasRealLotOptions(val) && !hasLotCodeString(val)) return false;
    this.onSelectItem(val, false);
    return true;
  }
  showScanner(value) {
    this.setState({ scan: value, scanerCanceled: value ? false : this.state.scanerCanceled });
  }
  renderInputView() {
    const { value } = this.state;
    const { width } = this.props;

    return <View style={{
      ...styles.input,
      borderColor: "#e7e7e7",
      borderRadius: 5,
      borderWidth: 1,
      color: "#424242",
      fontFamily: "Roboto",
      fontSize: 20,
      fontWeight: "400",
      paddingLeft: 10,
      height:
        Platform.OS === 'ios' ?
          this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) :
          this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder),
      fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal'
    }}></View>;
  }
  onSelectedItemsChange(lotsSelected) {
    const { onSelectItem, initial } = this.props;
    this.onSelectItem(lotsSelected, true);
  }
  filllocationFromLotsView(componentId, location) {
    const { components, onChange, id } = this.props;
    var locationComponent = getComponentByanotherComponentId(componentId, "location", components);
    if (locationComponent) {
      onChange(id, location);
    }
  }
  isInventoryForm() {
    const { isRequisitionForm, isShipmentLog, isReceivingLog, isInvoice, isInventoryTransfer, isRecipe, isOrder } = this.props;
    return !!(isRequisitionForm || isShipmentLog || isReceivingLog || isInvoice || isInventoryTransfer || isRecipe || isOrder);
  }
  hasRealLotOptions(lotCodes) {
    if (!Array.isArray(lotCodes) || lotCodes.length === 0) return false;
    return lotCodes.some((lot) => {
      if (!lot) return false;
      if (typeof lot === "string") return lot.trim().length > 0;
      // Named lot codes
      if (lot.lot != null && String(lot.lot).trim().length > 0) return true;
      // Inventory rows with lot: "" still have selectable stock
      if (lot.isNew) return false;
      if (parseFloat(lot.totalAmount) > 0 || parseFloat(lot.amount) > 0) return true;
      if (Array.isArray(lot.historial)) {
        return lot.historial.some((batch) => !batch?.hide && parseFloat(batch?.amount) > 0);
      }
      return false;
    });
  }
  isShipmentLotAllocated(lotCode, itemName) {
    const { isShipmentLog, alreadyAllocatedShipmentLots, currentSubmissionId } = this.props;
    if (!isShipmentLog || !alreadyAllocatedShipmentLots?.length) return false;

    const lotNorm = (typeof lotCode === "string"
      ? lotCode
      : (lotCode?.lot || lotCode?.lotcode || "")
    ).toString().trim().toLowerCase();
    const batchId = typeof lotCode === "object"
      ? (lotCode.batchId || lotCode._id || lotCode.id || null)
      : null;
    if ((!lotNorm || lotNorm === "default_lot") && !batchId) return false;

    const itemNorm = (itemName || this.state.ingredientName || "").toString().trim().toLowerCase();

    return isLotFullyAllocated(lotCode, alreadyAllocatedShipmentLots, {
      lot: lotNorm,
      batchId,
      itemName: itemNorm,
      currentSubmissionId,
    });
  }
  getRemainingAmountForShipmentLot(lotCode, itemName) {
    const { alreadyAllocatedShipmentLots, currentSubmissionId } = this.props;
    const lotNorm = (typeof lotCode === "string"
      ? lotCode
      : (lotCode?.lot || lotCode?.lotcode || "")
    ).toString().trim().toLowerCase();
    const batchId = typeof lotCode === "object"
      ? (lotCode.batchId || lotCode._id || lotCode.id || null)
      : null;
    const itemNorm = (itemName || this.state.ingredientName || "").toString().trim().toLowerCase();
    return getRemainingLotAmount(lotCode, alreadyAllocatedShipmentLots, {
      lot: lotNorm,
      batchId,
      itemName: itemNorm,
      currentSubmissionId,
    });
  }
  getShipmentItemNameForAllocation(submission, position) {
    const { components, section_id, defaultLabel } = this.props;
    if (this.state.ingredientName) return this.state.ingredientName;
    if (!components || !submission) return "";
    let nameLabels = ["ingredient", "packagingMaterial", "item", "itemName"];
    if (defaultLabel === "lotcode_finished" || defaultLabel === "lotcode_wip") {
      nameLabels = ["item", "itemName"];
    }
    const nameComp = components.find(
      (c) => c.section_id === section_id && nameLabels.indexOf(c.defaultLabel) >= 0
    );
    if (!nameComp) return "";
    const val = submission[nameComp.id];
    if (position || position === 0) return val && val[position] != null ? val[position] : "";
    if (Array.isArray(val)) return val[0] || "";
    return val || "";
  }
  filterUnallocatedShipmentLots(lotCodes, submission, position) {
    if (!Array.isArray(lotCodes)) return [];
    if (!this.props.isShipmentLog) return lotCodes;
    const itemName = this.getShipmentItemNameForAllocation(submission, position);
    return lotCodes.filter((lotCode) => !this.isShipmentLotAllocated(lotCode, itemName));
  }
  submissionHasOnlyPlaceholderLots(submission) {
    const currentLots = this.getSubmissionLots(submission);
    return Array.isArray(currentLots) && currentLots.length > 0 && currentLots.every(isPlaceholderLotObject);
  }
  gotLotDefaultLabel(defaultLabel) {
    return (defaultLabel == "lotcode" || defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip" || defaultLabel == "lot");
  }
  getPreselectedLotCodes(defaultLabel, id, components, submission, position, lotCodes) {
    const { isReceivingLog, isShipmentLog } = this.props;
    const { value } = this.state;
    var quantity = "";
    var units = "";
    var quantityComponent = null;
    var unitsComponent = null;
    unitsComponent = getComponentByanotherComponentId(id, "units", components);
    var preselectedLots = [];
    if (defaultLabel == "lotcode") {
      quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
      if (!quantityComponent && this.props.isShipmentLog) quantityComponent = getComponentByanotherComponentId(id, "quantityIngredient", components);
      if (!quantityComponent && this.props.isShipmentLog) quantityComponent = getComponentByanotherComponentId(id, "quantityPackaging", components);
    } else if (defaultLabel == "lotcode_finished") {
      quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
    } else if (defaultLabel == "lotcode_wip") {
      quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
    }
    if (quantityComponent) {
      quantity = getComponentSubmissionByDefaultLabel(quantityComponent.defaultLabel, components, submission, quantityComponent.section_id, position);
    }
    if (unitsComponent) {
      units = getComponentSubmissionByDefaultLabel(unitsComponent?.defaultLabel, components, submission, unitsComponent?.section_id, position);
    }
    if (quantity) quantity = parseFloat(quantity);
    // For shipment logs, skip lots already allocated elsewhere and try the next available ones.
    const selectableLotCodes = isShipmentLog
      ? this.filterUnallocatedShipmentLots(lotCodes, submission, position)
      : lotCodes;
    if (quantity > 0) {
      const placeholderOnly = this.submissionHasOnlyPlaceholderLots(submission);

      // Quantity sync may create empty placeholder rows before real lots load — still preselect when options exist.
      if (placeholderOnly && !this.hasRealLotOptions(selectableLotCodes)) {
        const updated = JSON.parse(JSON.stringify(this.getSubmissionLots(submission)));
        updated.forEach((lot) => {
          lot.editedAmount = (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity;
        });
        return updated;
      }

      const existingReceivingLots = isReceivingLog ? this.getExistingLotsForQuantitySync(submission) : null;
      if (existingReceivingLots && existingReceivingLots.length > 0) {
        var quantityOnlOts = 0;
        existingReceivingLots.map((lotCode) => {
          quantityOnlOts += parseFloat(lotCode.editedAmount || 0);
        });
        if (quantityOnlOts < quantity || quantityOnlOts > quantity) {
          var dividedQuantity = (quantity / existingReceivingLots.length).toFixed(3);
          existingReceivingLots.map((lotCode) => {
            lotCode.editedAmount = dividedQuantity;
            quantity = quantity - parseFloat(dividedQuantity);
          });
          return existingReceivingLots;
        }
        return existingReceivingLots;
      }

      // Keep an existing real selection when its total already matches the row quantity.
      // Closing LotsByLocation updates quantity and used to rebuild lots in FIFO order,
      // wiping the lots the user just picked in the modal.
      const existingSelectedLots = this.getExistingLotsForQuantitySync(submission);
      if (
        existingSelectedLots &&
        existingSelectedLots.length > 0 &&
        (hasLotCodeString(existingSelectedLots) || this.hasRealLotOptions(existingSelectedLots))
      ) {
        const selectedTotal = parseFloat(getTotalSelected(existingSelectedLots));
        if (!Number.isNaN(selectedTotal) && Math.abs(selectedTotal - quantity) < 0.001) {
          return existingSelectedLots;
        }
      }

        selectableLotCodes.map((lotCode, idx) => {
          if (quantity > 0) {
            if (lotCode?.historial) {
              let lotRemaining = isShipmentLog
                ? this.getRemainingAmountForShipmentLot(lotCode, this.getShipmentItemNameForAllocation(submission, position))
                : Infinity;
              lotCode.historial.reverse().map((batch) => {
                if (quantity > 0 && lotRemaining > 0) {
                  var maxTake = parseFloat(batch?.amount) || 0;
                  if (lotRemaining < maxTake) maxTake = lotRemaining;
                  if (quantity < maxTake) maxTake = quantity;
                  if (maxTake > 0) {
                    batch.editedAmount = (maxTake % 1 > 0 && !validateDecimals(maxTake.toString())) ? maxTake.toFixed(3) : maxTake;
                    quantity -= maxTake;
                    if (lotRemaining !== Infinity) lotRemaining -= maxTake;
                  } else {
                    batch.hide = true;
                  }
                } else {
                  batch.hide = true;
                }

                return batch;
              })
            }
            preselectedLots.push(lotCode);
          }
        })
      if (quantity > 0) {
        preselectedLots.push({
          lot: "",
          historial: [],
          minDate: "",
          production_date: "",
          totalAmount: 0,
          editedAmount: (quantity % 1 > 0 && !validateDecimals(quantity.toString())) ? quantity.toFixed(3) : quantity,
          isNew: true,
          units
        })
      }
    } else {
      // Quantity 0/empty: do not auto-pick a lot at full stock — that is treated as
      // selecting the entire on-hand amount and incorrectly trips partial-allocation alerts
      // (e.g. 0.1 on hand with 0.05 already allocated elsewhere).
      preselectedLots = isShipmentLog ? [] : (selectableLotCodes?.length ? [selectableLotCodes[0]] : []);
    }
    return preselectedLots;
  }
  inputBlur(blur) {
    if (this.textInputRef.current) {
      this.setState({ leftWriting: true });
      if (blur) this.textInputRef.current.blur();
    }
    if(this._interval)clearTimeout(this._interval);
  }
  showScannerInput() {
    const { setFormScroll } = this.props;
    if (!this.state.scanerCanceled) {
      if (setFormScroll) setFormScroll(false);
      setTimeout(() => {
        this.showScanner(true);
        setTimeout(() => {
          if (setFormScroll) setFormScroll(true);
        }, 300);
      }, 500);
    } else {
      this.setState({ scanerCanceled: false });
    }
  }
  preventModalScroll(setFormScroll, callback) {
    if (setFormScroll) setFormScroll(false);
    const scheduledGen = this._lotsViewGen;
    setTimeout(() => {
      if (scheduledGen !== this._lotsViewGen) return;
      if (callback) callback();
      setTimeout(() => {
        if (scheduledGen !== this._lotsViewGen) return;
        if (setFormScroll) setFormScroll(true);
      }, 300);
    }, 300);
  }

  getLotsPickerContext(submission) {
    const { units } = this.props;
    const { value } = this.state;
    const submissionLots = this.getSubmissionLots(submission);
    let lotsSelected = value || "";
    if (Array.isArray(submissionLots) && submissionLots.length > 0) {
      lotsSelected = JSON.parse(JSON.stringify(submissionLots));
    }
    const qty = this.getQuantityValueForLotSync(submission);
    const amount = qty != null && qty !== "" ? parseFloat(qty) : "";
    return { lotsSelected, amount, units };
  }
  /** Open lots picker (receiving forms). Called only from explicit user press. */
  openLotsPickerFromInventoryPress = (ingredientName) => {
    const { setFormScroll, setShowTextBar, id, position, options, isInventoryReceivingForm, isRecipe, defaultLabel, submission } = this.props;
    const { value } = this.state;
    if (!isInventoryReceivingForm || !this.gotLotDefaultLabel(defaultLabel)) return;
    if (!this.hasLotSearchText(value)) return;
    if (this._lotsPickerOpening) return;
    this._lotsPickerOpening = true;
    this._lotsViewGen++;
    this.preventModalScroll(setFormScroll, () => {
      const usesKeyboardBar = isMobileWeb() || Platform.OS === "android";
      if (usesKeyboardBar && setShowTextBar) {
        if (!(isRecipe && ingredientName && ingredientName.trim().toLowerCase() == "water")) {
          const { lotsSelected, amount, units } = this.getLotsPickerContext(submission);
          setShowTextBar(id, position, options || [], ingredientName, lotsSelected, units, amount, true);
        }
      }
      if (!isMobileWeb()) {
        this.setState({ showLotsByLocation: true });
      }
      this._lotsPickerOpening = false;
    });
  };

  handleLotInputPress = (ingredientName, value, amount, defaultLabel) => {
    const { isInventoryReceivingForm, scannerInput, showScanner } = this.props;
    const { scanerCanceled } = this.state;
    if (
      isInventoryReceivingForm &&
      defaultLabel != "lot" &&
      this.gotLotDefaultLabel(defaultLabel)
    ) {
      if (this.hasLotSearchText(value)) {
        this.openLotsPickerFromInventoryPress(ingredientName);
        return true;
      }
      if (scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
        this.showScannerInput();
        return true;
      }
      return false;
    }
    if (scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
      if (this.canOpenEmbeddedLotsFromRow(value, ingredientName, amount, isInventoryReceivingForm)) {
        if (isMobileWeb()) {
          this.openLotsPickerFromInventoryPress(ingredientName);
        } else {
          this._lotsViewGen++;
          this.setState({ showLotsByLocation: true });
        }
      } else {
        this.showScannerInput();
      }
      return true;
    }
    return false;
  };

  canOpenEmbeddedLotsFromRow(value, ingredientName, amount, isInventoryReceivingForm) {
    return (
      lotFieldHasMeaningfulLots(value) ||
      (((typeof value === "string" && value.trim().length > 0) ||
        (Array.isArray(value) && value.length > 0)) &&
        isInventoryReceivingForm &&
        receivingRowHasProductForLotsPicker(ingredientName, amount))
    );
  };
  render() {
    const { value, scan, reset, ingredientOptions, showLotsByLocation, leftWriting, loadedLots, loadingBatchSizeChange, scanerCanceled, softFocus, lotInputFocused } = this.state;
    const { label, onChange, id, isIssuable, onSubmitIssue, isCompleted, showScanner, showLotGenerator, width, openIssue, defaultComponent, handleFocusOnElement, showInventorySearch, defaultLabel, isShipmentLog, options, submission, showWipSearch, isRecipe, isInvoice, isInventoryTransfer, openDropDown, backgroundColor, isDropDownOpened, closeSearch, hideInput, components, position, setShowTextBar, setOpenBarcode, openBarCodeScanner, scannerInput, rerenderTable, minorAmountAndroid, minorAmountPosition, newReport, isInventoryReceivingForm, isReceivingLog, defaultYield, setFormScroll, complete_date } = this.props;
    const type = defaultLabel == "lotcode_finished" ? "Finished goods" : defaultLabel == "lotcode_wip" ? "Work in progress" : showWipSearch ? "Work in progress" : "";
    const requiredAmount = isInventoryReceivingForm ? getRequiredAmount(components, id, position, isRecipe, submission, defaultLabel, defaultYield) : 0;
    var minorAmount = false;
    //const isInventoryForm = this.isInventoryForm();
    if (isRecipe)
      if (newReport) {
        minorAmount = ((parseFloat(getTotalSelected(value)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(value)) > parseFloat(requiredAmount)) && loadedLots && !loadingBatchSizeChange);
      } else {
        minorAmount = (parseFloat(getTotalSelected(value)) < parseFloat(requiredAmount) || parseFloat(getTotalSelected(value)) > parseFloat(requiredAmount) && !loadingBatchSizeChange);
      }

    var ingredientName = "";
    var units = "";
    var amount = "";

    if (isInventoryReceivingForm) {
      ingredientName = getComponentSubmit(submission, components, "ingredient", id, position);
      if (!ingredientName) ingredientName = getComponentSubmit(submission, components, "name", id, position);
      if (!ingredientName) ingredientName = getComponentSubmit(submission, components, "item", id, position);

      amount = getComponentSubmit(submission, components, "quantity", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityIngredient", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityFinishedGoods", id, position);
      if (!amount) amount = getComponentSubmit(submission, components, "quantityWIP", id, position);
      if (amount) amount = parseFloat(amount);
    }
    if (isInventoryReceivingForm) units = getComponentSubmit(submission, components, "units", id, position);

    const canOpenEmbeddedLotsFromRow = this.canOpenEmbeddedLotsFromRow(value, ingredientName, amount, isInventoryReceivingForm);
    const pickerCtx = this.getLotsPickerContext(submission);

    return (
      <View ref={this.inputRef}>
        {scan ?
          <View style={{
            ...styles.container,
            paddingTop: width ? 0 : 5,
            flex: 1
          }}>
            <BarcodeScannerComponent
              onBarCodeScanned={(e) => {
                this.handleBarCodeScanned(e);
              }}
              closeScanner={() => {
                this.showScanner(false);
                if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                  this.setState({ scanerCanceled: true }, () => {
                    setTimeout(() => {
                      if (inputFocus) inputFocus(this.textInputRef);
                    }, 200);
                  })
                }
              }}
              style={styles.absoluteFillObject}
            />
          </View>

          :
          <>
            {/* Native iOS/Android: embedded picker. Mobile web uses Form-level LotsByLocation. */}
            {showLotsByLocation && !isMobileWeb() ?
              <LotsByLocation units={pickerCtx.units} amount={pickerCtx.amount} lotsSelected={pickerCtx.lotsSelected} options={options ? options : []} id={id} position={position} name={ingredientName} onBack={(editQty, totalSelected, minorAmount, selectedLots) => {
                this.markLotsPickerClosed();
                this._suppressLotQtySyncUntil = Date.now() + 800;
                this.inputBlur(true);
                if (setShowTextBar) {
                  setShowTextBar(null, null, null, null, null, null, null, false);
                }
                // Persist the modal selection before any quantity sync can rebuild FIFO lots.
                if (selectedLots != null) {
                  this.onSelectedItemsChange(selectedLots);
                }
                setTimeout(() => {
                  this.setState({ showLotsByLocation: false, minorAmount });
                }, 100);
                //Edit Qty
                if (
                  //!isRecipe && 
                  onChange && editQty
                ) {
                  var quantityComponent = null;
                  if (isShipmentLog) {
                    if (defaultLabel == "lotcode_finished") {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityFinishedGoods", components);
                    } else if (defaultLabel == "lotcode_wip") {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityWIP", components);
                    } else if (getComponentByanotherComponentId(id, "quantityIngredient", components)) {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityIngredient", components);
                    } else {
                      quantityComponent = getComponentByanotherComponentId(id, "quantityPackaging", components);
                    }
                  } else {
                    quantityComponent = getComponentByanotherComponentId(id, "quantity", components);
                  }
                  if (quantityComponent) onChange(quantityComponent.id, totalSelected, false)
                }
              }} placeholder={"Search by lot code"} onSelect={(selected, location) => {
                this.onSelectedItemsChange(selected);
                if (isRecipe && location) this.filllocationFromLotsView(id, location);
              }} filllocationFromLotsView={(location) => this.filllocationFromLotsView(id, location)} components={components} openAlert={(value) => this.setState({ showLotsByLocation: !value })} requiredAmount={requiredAmount} isInventoryReceivingForm={isInventoryReceivingForm} isInventoryType={defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip"} isReceivingLog={isReceivingLog} setFormScroll={setFormScroll} isRecipe={isRecipe} isShipmentLog={isShipmentLog} complete_date={complete_date} alreadyAllocatedShipmentLots={this.props.alreadyAllocatedShipmentLots} currentSubmissionId={this.props.currentSubmissionId}/> : null}
            {(this.state.dialogVisible && !width) &&
              <View style={{...styles.container,
                paddingTop: width ? 0 : 5,
                height: 150
              }}>
                <NewIssue
                  visible={this.state.dialogVisible}
                  id={id}
                  label={label}
                  onSubmitIssue={onSubmitIssue}
                  handleClose={() => this.setState({ dialogVisible: false })}
                />
              </View>
            }
            {!this.state.dialogVisible &&
              <View style={{
                ...styles.container,
                paddingTop: width ? 0 : 5,
                flex: 1
              }}>
                {
                  label ?
                    <Text style={styles.label}>
                      {label}
                    </Text>
                    : null
                }
                {
                  (isIssuable && isCompleted) &&
                  <TouchableOpacity style={{ paddingBottom: 10, paddingTop: 5 }} onPress={() => {
                    if (width) {
                      openIssue();
                    } else {
                      this.setState({ dialogVisible: true });
                    }
                  }}>
                    <Text style={{ color: colors.primary, fontWeight: 'bold' }}>Issue</Text>
                  </TouchableOpacity>
                }
                <View style={styles.inputContainer}>
                  <View style={styles.inputC}>
                    {
                      (showInventorySearch && (!isShipmentLog && !isRecipe && !isInvoice && !isInventoryTransfer)) &&
                      <SearchInventory onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                          this.showScanner(true);
                        }
                      }} closeSearch={closeSearch} showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val) => this.onSelectItem(val)} initial={value} type={type} searchBy={'lot'} isShipmentLog={isShipmentLog} options={options} defaultLabel={defaultLabel} reset={reset} id={id} submission={submission} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} />
                    }
                    {/* //For recipes */}
                    {
                      ((showInventorySearch || this.isShipmentLotField()) && (ingredientOptions?.length > 0) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog)) &&
                      <SearchIngredientsByLot showScanner={showScanner} defaultComponent={defaultComponent} onSelectItem={(val) => {
                        if (isRecipe && defaultLabel == "lotcode")
                          this.onSelectItem(val, true);
                        else
                          this.onSelectItem(val);
                      }} onFocus={() => {
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                        if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                          this.showScanner(true);
                        }
                      }} closeSearch={closeSearch} initial={value} type={type} searchBy={'lot'} isRecipe={isRecipe} isInvoice={isInvoice} isInventoryTransfer={isInventoryTransfer} options={ingredientOptions} defaultLabel={defaultLabel} reset={reset} id={id} submission={submission} width={width} isShipmentLog={isShipmentLog} openDropDown={openDropDown} backgroundColor={backgroundColor} isDropDownOpened={isDropDownOpened} components={components} position={position} setShowTextBar={setShowTextBar} scanOptionPress={() => {
                        this.showScanner(true);
                        setTimeout(() => {
                          if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                        }, 300);
                      }} ingredientName={ingredientName} units={units} amount={amount} rerenderTable={rerenderTable} gotLotDefaultLabel={this.gotLotDefaultLabel(defaultLabel)} onChange={onChange} minorAmountAndroid={minorAmountAndroid} minorAmount={minorAmount} requiredAmount={requiredAmount} isInventoryReceivingForm={isInventoryReceivingForm} isReceivingLog={isReceivingLog} isInventoryForm={this.isInventoryForm()} setFormScroll={setFormScroll} complete_date={complete_date} alreadyAllocatedShipmentLots={this.props.alreadyAllocatedShipmentLots} currentSubmissionId={this.props.currentSubmissionId} onLotsPickerClosing={() => { this._suppressLotQtySyncUntil = Date.now() + 800; }} />
                    }
                    {
                      (!(showInventorySearch && (!isShipmentLog && !isRecipe && !isInvoice && !isInventoryTransfer)) &&
                        !((showInventorySearch || this.isShipmentLotField()) && (ingredientOptions?.length > 0) && (isRecipe || isInvoice || isInventoryTransfer || isShipmentLog))) ?
                        hideInput ? this.renderInputView() :
                          <View
                            style={{
                              flexDirection: (isInventoryReceivingForm && defaultLabel != "lot") ? 'row' : 'column',
                              justifyContent: (isInventoryReceivingForm && defaultLabel != "lot") ? 'center' : 'none',
                              alignItems: (isInventoryReceivingForm && defaultLabel != "lot") ? 'center' : 'none',
                              //paddingInline: (isInventoryReceivingForm && defaultLabel != "lot") ? 5 : 0,
                              borderRadius: (isInventoryReceivingForm && defaultLabel != "lot") ? 20 : 0,
                              //backgroundColor: 'red',
                              paddingInline: (isInventoryReceivingForm && defaultLabel != "lot") && typeof value == "object" ? 12 : 0,
                              backgroundColor: (isInventoryReceivingForm && defaultLabel != "lot") ? typeof value == "object" && minorAmount ? colors.quit : colors.primary : 'none',
                            }}
                          >
                            <View style={{ width: isInventoryReceivingForm ? '100%' : 'auto', position: 'relative' }}>
                            <TextInput
                              {...getNoAutofillProps()}
                              //value={typeof value == "string" ? value : ""}
                              value={typeof value == "string" ? value : typeof value == "object" ? getLotCodeString(value) : ""}
                              editable={!defaultComponent && !(isRecipe && ingredientName.trim().toLowerCase() == "water") && !(scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled && Platform.OS == "ios")}
                              ref={noAutofillRef(this.textInputRef)}
                              showSoftInputOnFocus={Platform.OS == "ios" ? true : softFocus}
                              onPress={() => this.handleLotInputPress(ingredientName, value, amount, defaultLabel)}
                              onPressIn={() => {
                                if (!this._lotsPickerOpening) {
                                  this.handleLotInputPress(ingredientName, value, amount, defaultLabel);
                                }
                              }}
                              onBlur={() => {
                                if (isInventoryReceivingForm && defaultLabel != "lot") {
                                  this.setState({ lotInputFocused: false });
                                }
                                if (scannerInput && (showScanner || isInventoryReceivingForm)) {
                                  this.setState({ scanerCanceled: false });
                                  if (softFocus) this.setState({ softFocus: false });
                                }
                              }}
                              onFocus={() => {
                                if (isInventoryReceivingForm && defaultLabel != "lot") {
                                  this.setState({ lotInputFocused: true });
                                }
                                if (!this.shouldAllowEmbeddedLotsView()) return;
                                setTimeout(() => {
                                  if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                                }, 300);
                                if (
                                  scannerInput &&
                                  (showScanner || isInventoryReceivingForm) &&
                                  !scanerCanceled &&
                                  Array.isArray(value) &&
                                  lotFieldHasMeaningfulLots(value)
                                ) {
                                  return;
                                }
                                if (isInventoryReceivingForm && defaultLabel != "lot") {
                                  if (!canOpenEmbeddedLotsFromRow || !leftWriting) {
                                    if (Platform.OS != "ios" && scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
                                      this.showScannerInput();
                                      if (!softFocus) {
                                        this.setState({ softFocus: true });
                                        return;
                                      }
                                    }
                                  }
                                  this.preventModalScroll(setFormScroll, () => {
                                    const usesKeyboardBar = isMobileWeb() || Platform.OS === "android";
                                    if (setShowTextBar && usesKeyboardBar && this.gotLotDefaultLabel(defaultLabel)) {
                                      if (!(isRecipe && ingredientName.trim().toLowerCase() == "water")) {
                                        const pickerCtx = this.getLotsPickerContext(submission);
                                        setShowTextBar(id, position, [], ingredientName, pickerCtx.lotsSelected, pickerCtx.units, pickerCtx.amount, false);
                                      }
                                    }
                                  });
                                } else {
                                  if (Platform.OS != "ios" && scannerInput && (showScanner || isInventoryReceivingForm) && !scanerCanceled) {
                                    this.showScannerInput();
                                    if (!softFocus) {
                                      this.setState({ softFocus: true });
                                      return;
                                    }
                                  }
                                  if (setShowTextBar) {
                                    setShowTextBar(null, null, null, null, null, null, null, false)
                                  }
                                }
                              }}
                              inputAccessoryViewID={this.state.inputAccessoryViewID}
                              scrollEnabled={isRecipe ? false : true}
                              style={{
                                ...styles.input,
                                // Yield lot only: match Yield/To Location vertical centering (other lot fields unchanged).
                                paddingTop: (isRecipe && defaultLabel == "lot")
                                  ? 5
                                  : ((isRecipe && Platform.OS == "ios" && defaultLabel == "lot") ? 10 : isInventoryReceivingForm ? 5 : 0),
                                justifyContent: (isRecipe && defaultLabel == "lot")
                                  ? "center"
                                  : ((isRecipe && Platform.OS == "ios" && defaultLabel == "lot") ? "center" : "flex-end"),
                                borderColor: (isInventoryReceivingForm && defaultLabel == "lot") ? colors.orange : "#e7e7e7",
                                borderRadius: (isInventoryReceivingForm && defaultLabel != "lot") ? 20 : (isInventoryReceivingForm && defaultLabel == "lot") ? 10 : 5,
                                borderWidth: ((isInventoryReceivingForm && width && defaultLabel != "lot")) ? 0 : 1,
                                color: isInventoryReceivingForm ? defaultLabel == "lot" ? colors.orange : 'white' : "#424242",
                                fontFamily: "Roboto",
                                fontSize: isInventoryReceivingForm ? 14 : 20,
                                fontWeight: "400",
                                //paddingLeft: 10,
                                padding: isInventoryReceivingForm ? 5 : 10,
                                //paddingVertical: isRecipe ? Platform.OS == "ios" ? 8 : 0 : 0,
                                marginTop: (isInventoryReceivingForm && defaultLabel == "lot") ? 15 : isInventoryReceivingForm ? 0 : 5,
                                textAlign: isInventoryReceivingForm ? 'center' : 'left',
                                textAlignVertical: (isRecipe && defaultLabel == "lot") ? "center" : undefined,
                                backgroundColor: (isInventoryReceivingForm && defaultLabel != "lot") ? typeof value == "object" && minorAmount ? colors.quit : colors.primary : 'none',
                                height:
                                  (isRecipe && defaultLabel == "lot")
                                    ? (Platform.OS === "ios" ? 44 : 50)
                                    : (Platform.OS === 'ios' ?
                                      this.state.value !== '' ? this.state.heightIOS * getIosCellHeight(width, value) : this.state.heightIOS * getIosCellHeight(width, this.props.placeholder) :
                                      this.state.value !== '' ? this.state.height * getIosCellHeight(width, value) : this.state.height * getIosCellHeight(width, this.props.placeholder)),
                                fontStyle: this.state.value == "" || !this.state.value ? 'italic' : 'normal',
                                width: isInventoryReceivingForm ? '100%' : 'auto',
                                marginVertical: (isInventoryReceivingForm && defaultLabel != "lot") && typeof value == "object" ? 1 : 0,
                                cursor: isInventoryReceivingForm && defaultLabel == "lotcode" && value && leftWriting ? 'pointer' : 'auto',
                                ...(isRecipe && defaultLabel == "lot" && Platform.OS === "web"
                                  ? { display: "flex", alignItems: "center" }
                                  : null),
                              }}
                              multiline={!(isRecipe && defaultLabel == "lot")}
                              numberOfLines={(isRecipe && defaultLabel == "lot") ? 1 : undefined}
                              // scrollEnabled={false}
                              placeholder={this.props.placeholder ? this.props.placeholder : ""}
                              placeholderTextColor={(isRecipe && defaultLabel != "lot") ? 'white' : 'rgb(0, 47, 108)'}
                              onChangeText={(val) => {
                                if (!defaultComponent) {
                                  if (isInventoryReceivingForm && defaultLabel != "lot") {
                                    if(this._interval)clearTimeout(this._interval);
                                    this._interval = setTimeout(() => this.inputBlur(false), 500);
                                    if (val.trim().length > 0) {
                                      this.setState({ leftWriting: true });
                                    }
                                  }
                                  this.setState({ value: val });
                                  if(isInventoryReceivingForm)this.setState({ softFocus: false });
                                  onChange(id, val);
                                }
                              }}
                            />
                            {isInventoryReceivingForm && defaultLabel != "lot" && this.hasLotSearchText(value) && !lotInputFocused ? (
                              <TouchableOpacity
                                activeOpacity={1}
                                style={StyleSheet.absoluteFill}
                                onPress={() => this.handleLotInputPress(ingredientName, value, amount, defaultLabel)}
                              />
                            ) : null}
                            </View>
                            {typeof value == "object" && value.length > 1 && <Text style={styles.lotsSelectedViewTxt}>+{value?.length - 1}</Text>}
                            {Platform.OS == "ios" && !value && <InputAccessoryView nativeID={this.state.inputAccessoryViewID}>
                              {(isInventoryReceivingForm && !(isRecipe && ingredientName.trim().toLowerCase() == "water")) && !(scannerInput && (showScanner || isInventoryReceivingForm) && !value && !scanerCanceled) && <KeyboardBar abcOptionPress={() => {
                                if (!this.shouldAllowEmbeddedLotsView() || !this.hasLotSearchText(value)) return;
                                this._lotsViewGen++;
                                this.setState({ showLotsByLocation: true });
                              }} scanOptionPress={() => {
                                this.showScanner(true);
                                setTimeout(() => {
                                  if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                                }, 300);
                              }} />}
                            </InputAccessoryView>
                            }
                          </View> : null
                    }
                    {
                      showScanner && !scannerInput && !isInventoryReceivingForm &&
                      <TouchableOpacity style={styles.btnScan}
                        disabled={defaultComponent}
                        onPress={() => {
                          this.showScanner(true);
                          setTimeout(() => {
                            if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                          }, 300);
                        }}
                      >
                        <Text style={styles.txtScan}>
                          Scan
                        </Text>
                      </TouchableOpacity>
                    }
                    {
                      showLotGenerator &&
                      <TouchableOpacity style={styles.btnScan}
                        onPress={() => this.generateLotCode(999999999999, 10000000)}
                      >
                        <Text style={styles.txtScan}>
                          Generate Lot Code
                        </Text>
                      </TouchableOpacity>
                    }

                  </View>

                </View>
              </View>
            }
          </>
        }
      </View>
    );
  }
}
export default connect((state, ownProps = {}) => ({
}), (dispatch, props) => ({
  getIngredientLotsByName: (data, callback) => {
    dispatch(getIngredientLotsByName(data, callback));
  },
  dispatch: dispatch,
}))(Lotcode);

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    // paddingBottom: 10,
    // paddingHorizontal: 10,
    paddingTop: 5,
    //flex: 1,
  },
  input: {
    borderColor: "#e7e7e7",
    borderRadius: 5,
    borderWidth: 1,
    color: "#424242",
    fontFamily: "Roboto",
    fontSize: 25,
    fontWeight: "400",
    paddingLeft: 10,
  },
  label: {
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  inputContainer: {
    flex: 1,
    flexDirection: "column"
  },
  inputC: {
    flex: 3
  },
  btnC: {
    flex: 1
  },
  btnScan: {
    textAlign: "center",
    justifyContent: "center",
    backgroundColor: colors.primary,
    height: 30,
    borderRadius: 5,
    marginTop: 10
  },
  txtScan: {
    textAlign: "center",
    justifyContent: "center",
    color: "white"
  },
  absoluteFillObject: {
    height: 400,
    width: "100%",
  },
  btnCancel: {
    backgroundColor: colors.orange,
    justifyContent: "center",
    borderRadius: 5,
    marginTop: 10,

  },
  btnCancelText: {
    justifyContent: "center",
    textAlign: "center",
    padding: 5,
    color: "white"
  },
  lotsSelectedViewTxt: {
    color: 'white',
    borderWidth: 1,
    borderRadius: 5,
    padding: 2,
    borderColor: 'white',
    fontSize: 12,
    height: 20,
    //marginRight: 3,
    marginVertical: 4
  }
});
